// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1GlzN","inputWrap":"Table_inputWrap__C9wjj","col":"Table_col__gArqd","bmiTooltip":"Table_bmiTooltip__3NVP6"};